import { cacheFirstConfig, http } from '@/core/helpers/http.helper';
import { ApiResource } from '@/core/models/api-resource.interface';
import { LocationQuery } from 'vue-router';
import { CommunicationStatus } from './communication-status.interface';

export class CommunicationStatusService {
   async getCommunicationStatusses(query: LocationQuery) {
      const response = await http.get<ApiResource<Array<CommunicationStatus>>>(`/communication-statuses`, {
         ...cacheFirstConfig,
         params: { ...query },
      });
      return response.data;
   }
}
